/* eslint-disable vue/component-name-in-template-casing */
const Icons = [
  "file-invoice-dollar",
  "user-tie",
  "lightbulb",
  "award",
  "hat-chef",
  "microsoft",
  "chart-line-up",
  "compass-drafting",
  "paw",
  "comments",
  "car",
  "list-check",
  "circle-exclamation",
  "cart-shopping",
  "robot",
  "lock",
  "box",
  "paintbrush",
  "shield-halved",
  "truck-front",
  "books",
  "gears",
  "people",
  "table",
  "circle-sterling",
  "fire",
  "briefcase-medical",
  "burger-soda",
  "list",
  "building",
  "user-helmet-safety",
  "house-user",
  "hand-holding-heart",
  "shield-check",
  "laptop",
  "life-ring",
  "truck-ramp-box",
  "user-tie-hair-long",
  "brain",
  "file-word",
  "sparkles",
  "globe",
  "building-user",
  "puzzle-piece",
  "note",
  "gavel",
  "presentation-screen",
  "cart-shopping",
  "heart",
  "chart-mixed-up-circle-dollar",
  "business-time",
  "male",
  "female",
  "people-carry",
  "user-friends",
  "user-circle",
  "user-graduate",
  "portrait",
  "user",
  "user-shield",
  "smile",
  "frown",
  "id-card",
  "address-book",
  "balance-scale",
  "chart-pie",
  "credit-card",
  "piggy-bank",
  "handshake",
  "tags",
  "trophy",
  "envelope",
  "file",
  "folder",
  "question-circle",
  "globe",
  "comment-alt",
  "sitemap",
  "keyboard",
  "wifi",
  "at",
  "hourglass-start",
  "calendar",
  "save",
  "sticky-note",
  "plus-square",
  "medal",
  "minus-square",
  "battery-quarter",
  "door-closed",
  "exclamation-triangle",
  "exclamation",
  "ban",
  "briefcase",
  "bug",
  "donate"
];

export default Icons;
